import { useEffect, useRef } from "react";
import { BulkUpdateTable } from "../../components/Cards/BulkUpdateTable";
import useIsMobile from "../../hooks/Helper/useIsMobile";
import { Loader } from "../../components/Loader";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { FaFileExcel, FaPaperPlane } from "react-icons/fa";
import { BulkUpdate } from "../../types/bulkUpdate";
import { useTranslation } from "react-i18next";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ExcelJS from "exceljs";
import { messageMap } from "../../utils/messageMap";
import { exportToExcel, handleRequestEligibleClick } from "../../tools/utils";
import { RequestCertConnectBulkUpload } from "../../redux/thunks/bulkUpdateThunk";
import { useDispatch } from "react-redux";
import { analyticsService } from "../../services/analyticsService";


export const BulkUpload = ({ organizationId }: { organizationId: string }) => {
  const isMobile = useIsMobile();

  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();


  const { bulkUpdateList, error, loading, requestLoading } = useSelector(
    (state: RootState) => state.bulkUpload
  );

  const originalList = useRef<BulkUpdate[]>([]);

  useEffect(() => {
    if (bulkUpdateList.length > 0 && originalList.current.length === 0) {
      originalList.current = bulkUpdateList;
    }
  }, [bulkUpdateList]);

  return (
    <>

      <div className="cco_row cco_row_3" style={{ marginTop: "20px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginBottom: "0px",
          }}
        ></div>

        <div className={`bulk-toolbar ${isMobile ? 'bulk-toolbar--mobile' : ''}`}>

          {(loading || requestLoading) && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(255,255,255,0.7)",
                zIndex: 3000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Loader />
            </div>
          )}

          <div className="bulk-stats">
            {/* Total */}
            <span className="bulk-stats__item">
              {t('bulkUpload.Total')}
            </span>
            <span className="bulk-stats__item-badge">
              {bulkUpdateList.length}
            </span>

            <span className="divider">|</span>
            <>
              {/* Eligible */}
              <span className="bulk-stats__item">
                {t('bulkUpload.Eligible')}
              </span>
              <span
                className="bulk-stats__item-badge">
                {bulkUpdateList.filter((x) => x.Eligible).length}
              </span>

              <span className="divider">|</span>

              {/* Not Eligible */}
              <span className="bulk-stats__item">
                {t('bulkUpload.NotEligible')}</span>
              <span className="bulk-stats__item-badge">

                {bulkUpdateList.filter((x) => !x.Eligible).length}
              </span>




            </>

          </div>
          <div className="bulk-buttons">

            <button
              className={`bulk-buttons__btnExport ${isMobile ? 'mobile' : ''}`}
              onClick={() =>{ 
                analyticsService.handleExcelExportClicked();
                 exportToExcel(t, bulkUpdateList)
                }}
            >
              <FaFileExcel className={`icon ${isMobile ? 'mobile' : ''}`} />
              {t('bulkUpload.ExportResults')}
            </button>
            <button
              className={`bulk-buttons__btn ${isMobile ? 'mobile' : ''}`}
              onClick={async () => {
                const eligibleIds = bulkUpdateList
                  .filter(item => item.Eligible === true)
                  .map(item => item.CCOID);

                handleRequestEligibleClick();

                await dispatch(
                  RequestCertConnectBulkUpload({
                    orgId: organizationId,
                    CCOId: eligibleIds,
                  })
                );
              }}

            >
              {!requestLoading && <FaPaperPlane className={`icon ${isMobile ? 'mobile' : ''}`} />}

              {requestLoading
                ? t('bulkUpload.Requesting')
                : t('bulkUpload.RequestAllEligible')}
            </button>
          </div>
        </div>


        <div className="cco_col">
          <div className="cco_row cco_row_38">
            <div className="cco_col">
              {
                error ? (
                  <p
                    style={{
                      color: "red",
                      marginTop: "10px",
                      marginBottom: "10px",
                      textAlign: "center",
                    }}
                  >
                    {error}
                  </p>
                ) : bulkUpdateList && bulkUpdateList.length > 0 ? (
                  <div className="cco_group cco_group_myCredential">

                    <BulkUpdateTable />
                  </div>
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      marginTop: "20px",
                      color: "#666",
                    }}
                  >   {t('bulkUpload.NoDataAvailable')}
                  </p>
                )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

